// extracted by mini-css-extract-plugin
export var chip = "_mc-2";
export var chipBody = "_mc-8";
export var chipHeader = "_mc-9";
export var chipWithKind = "_mc-7";
export var icon = "_mc-3";
export var kind = "_mc-a";
export var remove = "_mc-5";
export var removeIcon = "_mc-6";
export var row = "_mc-0";
export var rowHistorical = "_mc-1";
export var text = "_mc-4";